// Feature cards row — native horizontal scroll (overflow-x:auto on
// .cards-section__stage, styles.css) with prev/next arrow buttons for
// discoverability on non-touch desktop.
//
// REPLACED 2026-08-29, per Martina: the previous version pinned the
// stage with GSAP ScrollTrigger and translated the row sideways as the
// page scrolled vertically (same technique as the 3D device section).
// Once Horizon's own .page-wrapper became the real scroll container at
// desktop widths, this section read as visibly shakier than every other
// pinned section on the page, and forcing native position:fixed pinning
// to fix that broke scrolling past it entirely. Unlike the 3D device or
// "breathing score" sections, this row never actually needed a scroll-
// linked *animation* — it just needs to move sideways — so it's back to
// plain native scroll (previously only the reduced-motion/mobile
// fallback, now the only mechanism, at every width), sidestepping the
// whole scroller-jank class of bug instead of continuing to fight it.
function initCardsScroll() {
  const stage = document.querySelector(".cards-section__stage");
  const row = document.getElementById("cardsRow");
  const nav = document.getElementById("cardsNav");
  const prevBtn = document.getElementById("cardsPrev");
  const nextBtn = document.getElementById("cardsNext");
  if (!stage || !row) return;

  // Arrows are an optional enhancement (desktop-only affordance — see
  // .cards-section__nav in styles.css, hidden below 951px since touch
  // swipe already covers mobile/tablet there). The row still works via
  // plain native scroll/swipe without them.
  if (!nav || !prevBtn || !nextBtn) return;

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  function updateArrowState() {
    const max = stage.scrollWidth - stage.clientWidth;
    prevBtn.disabled = stage.scrollLeft <= 1;
    nextBtn.disabled = stage.scrollLeft >= max - 1;
  }

  // Scrolls by roughly one card's width (+ its gap) per click — reads
  // the first real card's own rendered width rather than hardcoding a
  // px value, so it stays correct if the clamp()-sized card width ever
  // changes in CSS.
  function cardStep() {
    const firstCard = row.querySelector(".card:not(.card--empty)");
    if (!firstCard) return stage.clientWidth;
    const style = getComputedStyle(row);
    const gap = parseFloat(style.columnGap || style.gap || "0");
    return firstCard.getBoundingClientRect().width + gap;
  }

  function scrollByStep(direction) {
    stage.scrollBy({
      left: direction * cardStep(),
      behavior: reduceMotion ? "auto" : "smooth",
    });
  }

  prevBtn.addEventListener("click", () => scrollByStep(-1));
  nextBtn.addEventListener("click", () => scrollByStep(1));

  // Debounced, same reasoning as testimonials-carousel.js's own
  // scrollHandler — arrow disabled-state only needs to catch up once
  // scrolling settles, not track every frame of a swipe/scroll.
  let scrollTimer;
  stage.addEventListener(
    "scroll",
    () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateArrowState, 100);
    },
    { passive: true }
  );

  updateArrowState();

  // Card widths are viewport-relative (clamp()) and the row's total
  // scrollWidth changes with them — arrow disabled-state (based on
  // scrollWidth vs clientWidth) needs rechecking on resize, same as the
  // rest of this page's scroll-driven sections.
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateArrowState, 150);
  });
}

initCardsScroll();
